import fb_sdk from "./fb_sdk"
import ga_sdk from "./ga_sdk"
import fb_login from "./fb_login.vue"
import ga_login from "./ga_login.vue"
import Vue from "vue"
function createScript(d,s,sdk){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(sdk.script_id)) {return;}
    js = d.createElement(s); js.id = sdk.script_id;
    if(sdk.onload) js.onload = initga_Client;
    js.async = true; js.defer = true;
    js.src = sdk.src;
    fjs.parentNode.insertBefore(js, fjs);
}
function initga_Client(){
    try {
        let redirect_uri = "https://" + window.location.host;
        // eslint-disable-next-line no-undef
        window.ga_client = google.accounts.oauth2.initTokenClient({
            client_id:ga_sdk.client_id,
            scope:"https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
            redirect_uri:redirect_uri,
            access_type:"offline",
            ux_mode: 'popup',
            response_type:"code",
            callback:function(res){                
                if(typeof window[ga_sdk.callback] === "function"){
                     window[ga_sdk.callback](res)
                }
             }
        })     
    // eslint-disable-next-line no-empty
    } catch (error) {}  
}
let login_sdk = {
    install: function(Vue){
        Vue.component("fb-login",fb_login);
        Vue.component("ga-login",ga_login);
    }
}
Vue.use(login_sdk);
export default ()=>{        
    window.fbAsyncInit = function() {
        // eslint-disable-next-line no-undef
        FB.init({
          appId      : fb_sdk.appId,
          xfbml      : fb_sdk.xfbml,
          cookie     : fb_sdk.cookie,
          version    : fb_sdk.version
        });
        // eslint-disable-next-line no-undef
        FB.AppEvents.logPageView();
    };
    createScript(document,'script',fb_sdk);
    createScript(document,'script',ga_sdk);
}
